import { ROUTER_BASE_NAME } from '@/configs/env'
import { Suspense, useEffect } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'

import { RouteConfig } from '@/RouteConfig'
import { ComLoading } from '@/components/ComLoading'
import { registerAjaxHooks } from '@/helpers/registerAjaxHooks'
import { configStore } from '@/store'
import localStorage from '@/utils/localStorage'
import { getCookie, getUrlParam, isFunction, isObject } from '@/utils/utils'
import { isApp } from '@bcz/fe-interface'
import { OverlayConfigProvider } from '@bcz/ink'
import { useState } from 'react'
import { useEffectOnce } from 'react-use'
const store = configStore()
if (!isObject(window.bcz_system)) {
  // @ts-ignore
  window.bcz_system = {}
}
if (!isFunction(window.bcz_system.notifyApplicationEnterForegroundWhenPageOnTop)) {
  window.bcz_system.notifyApplicationEnterForegroundWhenPageOnTop = function () {}
}

function App() {
  const { code } = getUrlParam(location.search)
  const [isLogin, setIsLogin] = useState(0)
  // const [actReady, setActReady] = useState(false)
  useEffectOnce(() => registerAjaxHooks().unregister)

  useEffect(() => {
    if (!isApp) {
      const str = getCookie('mall_openid')
      localStorage.setItem('openid', decodeURIComponent(str))
      if (!str) {
        const a = `https://activity.baicizhan.com/api/common/auth/weixin/livecallback?&call_type=1&from_url=${encodeURIComponent(
          location.href,
        )}`
        const b = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3eaeff9db2a3c4e9&redirect_uri=${encodeURIComponent(
          a,
        )}&response_type=code&scope=snsapi_login&state=123456#wechat_redirect`

        location.replace(b)
      } else {
        setIsLogin(1)
      }
    } else {
      setIsLogin(1)
    }
  }, [code])

  if (isLogin !== 1) return <ComLoading full />
  return (
    <Provider store={store}>
      <OverlayConfigProvider>
        <Suspense fallback={null}>
          <Router basename={ROUTER_BASE_NAME}>
            <RouteConfig />
          </Router>
        </Suspense>
      </OverlayConfigProvider>
    </Provider>
  )
}

export default App
